import { ListFieldsKeys } from "src/api/config";
import { RootState } from "src/store/rootReducer";

export const selectCount = <K extends ListFieldsKeys>(state: RootState, listName: K): number => {
  return state.spitems.elements.count[listName] || 0;
};
